import React, { Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import { logoutUser } from '../features/users';
import AdminLayout from '../layouts/admin';
import DashboardLayout from '../layouts/dashboard';

const PrivateRoute = ({ isAdmin = false }) => {
    const { isAuthenticated, user } = useSelector((state) => state.users);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isAuthenticated) {
            localStorage.removeItem('token');
            dispatch(logoutUser());
            navigate('/login', { replace: true });
        } else if (isAdmin && (!user || user.role !== 'admin')) {
            navigate('/', { replace: true });
        }
    }, [isAuthenticated, user, isAdmin, dispatch, navigate]);

    const Layout = isAdmin ? AdminLayout : DashboardLayout;

    // Return null while redirecting
    if (!isAuthenticated || (isAdmin && (!user || user.role !== 'admin'))) {
        return null;
    }

    return (
        <Layout>
            <Suspense>
                <Outlet />
            </Suspense>
        </Layout>
    );
};

export default PrivateRoute;